import { Component, effect, Inject, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../environments/environment';
import { MainMenuComponent } from "./core/components/main-menu/main-menu.component";
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list'
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AuthService } from './core/services/auth.service';
import { User } from './core/models/user.model';
import { LoggingApplicationInsightsService } from './core/services/logging-application-insights/logging-application-insights.service';
import { Subject, take, takeUntil } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MainMenuComponent, MatButtonModule, MatIconModule, MatToolbarModule, MatSidenavModule, MatListModule, MatMenuModule, FontAwesomeModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'FoMa ' + environment.environmentName;
  public user!: User;
  private readonly ngUnsubscribe$ = new Subject<void>();
  private readonly isBrowser: boolean;

  constructor(
    public authService: AuthService,
    private loggingApplicationInsights: LoggingApplicationInsightsService,
    private router: Router,
    @Inject(PLATFORM_ID) platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);

    effect(async () => {
      this.user = this.authService.userDetails();
    })

    if (this.isBrowser) {
      this.createConsoleErrorHookToApplicationInsights();
    }
  }

  private createConsoleErrorHookToApplicationInsights() {
    const originalConsoleError = console.error;
    console.error = (...args: any[]) => {
      try {
        if (args[0] instanceof Error) {
          this.loggingApplicationInsights.logException(args[0]);
        } else {
          this.loggingApplicationInsights.logException(new Error(args.map(a => a && a.toString()).join(' ')));
        }
      } catch (e) {
        originalConsoleError('Error in console.error hook:', e);
      }
      originalConsoleError.apply(console, args);
    };
  }

  ngOnInit() {
    this.router.events.pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.loggingApplicationInsights.logPageView(event.urlAfterRedirects, event.urlAfterRedirects, { origin: this.constructor.name });
        }
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  isAuthenticated() {
    return this.authService.isAuthenticated();
  }
}
